<template>
  <div>
    <slot v-bind="slotProps" />
    <div class="load-more" v-if="hasMore">
      <button type="button" class="btn btn-block btn-default" :disabled="isLoading" @click="loadMore">
        {{ $t('loadMore', { pageSize: 25 }) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadMore',
  props: {
    load: { type: Function, required: true },
    name: { type: String, required: true },
  },
  data: () => ({
    items: [],
    response: {},
    hasMore: false,
    page: 1,
    isLoaded: false,
    isLoading: false,
  }),
  computed: {
    slotProps() {
      return {
        items: this.items,
        hasMore: this.hasMore,
        response: this.response,
        isLoaded: this.isLoaded,
      };
    },
  },
  methods: {
    loadItems(params) {
      this.isLoading = true;

      return this.load(params)
        .then((response) => {
          this.isLoaded = true;
          this.items = this.items.concat(response[this.name]);
          this.hasMore = response.hasMore;
          this.response = response;
          this.$emit('load', this.slotProps);
        })
        .finally(() => this.isLoading = false);
    },

    loadMore() {
      return this.loadItems({ page: this.page + 1 })
        .then(() => this.page++);
    },
  },
  created() {
    this.loadItems();
  },
};
</script>

<style scoped lang="scss">
.load-more {
  max-width: 300px;
  margin: 0 auto;
}
</style>
